import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';

function MarkdownWord({ content = '' }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkBreaks]}
      components={{
        p: ({ children }) => <p className="m-0 whitespace-pre-line">{children}</p>,
        strong: ({ children }) => <strong className="font-bold">{children}</strong>,
        em: ({ children }) => <em>{children}</em>,
      }}
    >
      {content}
    </ReactMarkdown>
  );
}

export default MarkdownWord;
